import { Box, Grid, TextInput } from '@ouster/webviz-react-components';

interface PublicAccessConfigProps {
  thumbnailUrl: string;
  setThumbnailUrl: (url: string) => void;
  title: string;
  setTitle: (title: string) => void;
}

export const PublicAccessConfig = ({
  thumbnailUrl,
  setThumbnailUrl,
  title,
  setTitle,
}: PublicAccessConfigProps) => (
  <Grid
    mt={6}
    rowGap={2}
    pt={4}
    borderTop="1px solid"
    borderColor="whiteAlpha.400"
    data-testid="public-access-config-root"
  >
    <Box
      as="p"
      fontSize={13}
      color="white"
      textTransform="uppercase"
      fontWeight="medium"
      mt={4}
    >
      Thumbnail link
    </Box>
    <TextInput
      bgColor="whiteAlpha.200"
      value={thumbnailUrl}
      onChange={(e) => setThumbnailUrl(e.currentTarget.value)}
      data-testid="public-access-config-thumbnail"
    />
    <Box
      as="p"
      fontSize={13}
      color="white"
      textTransform="uppercase"
      fontWeight="medium"
      mt={4}
    >
      Recording title
    </Box>
    <TextInput
      bgColor="whiteAlpha.200"
      value={title}
      onChange={(e) => setTitle(e.currentTarget.value)}
      data-testid="public-access-config-title"
    />
  </Grid>
);
